var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.656 261.656C352.781 258.531 352.781 253.469 349.656 250.344L197.656 98.344C196.094 96.781 194.062 96 192 96S187.906 96.781 186.344 98.344C183.219 101.469 183.219 106.531 186.344 109.656L324.688 248H8C3.594 248 0 251.578 0 256S3.594 264 8 264H324.688L186.344 402.344C183.219 405.469 183.219 410.531 186.344 413.656S194.531 416.781 197.656 413.656L349.656 261.656ZM448 440V72C448 67.582 444.418 64 440 64S432 67.582 432 72V440C432 444.418 435.582 448 440 448S448 444.418 448 440Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightToLine);
export default __webpack_public_path__ + "static/media/arrow-right-to-line.de52d1a0b9c83726971f23cc58e2d2ee.svg";
export { ForwardRef as ReactComponent };